import { Injectable } from "@angular/core";
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { BaseLookupService } from "../../impl/BaseLookupService";
import { IPositionBookLookupService } from "../IPositionBookLookupService";

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
export class PositionBookLookupService
  extends BaseLookupService<string, CubiqTS.PositionBookImpl>
  implements IPositionBookLookupService
{
  public defaultPositionBookId: string;

  constructor() {
    super(CubiqTS.PositionBookImpl);
  }

  getPositionBook(code: string): CubiqTS.PositionBookImpl {
    let posBook: CubiqTS.PositionBookImpl = this.getItem(code);

    return posBook;
  }

  getUserDefaultPositionBook(): CubiqTS.PositionBookImpl {
    if (this.defaultPositionBookId) {
      let posBook: CubiqTS.PositionBookImpl = this.getItem(this.defaultPositionBookId);
      return posBook;
    }
    return null;
  }

  getItemKey(item: CubiqTS.PositionBookImpl): string {
    return item.positionBookId.toString();
  }
}
